var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-info',{attrs:{"disabled":false,"loading":_vm.loading,"successText":_vm.$t('label_submit')},on:{"success":_vm.success,"cancel":_vm.cancel}})}
var staticRenderFns = []

export { render, staticRenderFns }